var Ei = Object.defineProperty, wi = Object.defineProperties;
var ki = Object.getOwnPropertyDescriptors;
var Dr = Object.getOwnPropertySymbols;
var Ai = Object.prototype.hasOwnProperty, Pi = Object.prototype.propertyIsEnumerable;
var Lr = (t, i, a) => i in t ? Ei(t, i, { enumerable: !0, configurable: !0, writable: !0, value: a }) : t[i] = a, e = (t, i) => {
  for (var a in i || (i = {}))
    Ai.call(i, a) && Lr(t, a, i[a]);
  if (Dr)
    for (var a of Dr(i))
      Pi.call(i, a) && Lr(t, a, i[a]);
  return t;
}, s = (t, i) => wi(t, ki(i));
import { LAYOUT_NODE_SHARED_CONTENT as vr, CONTENT_NODE_NAVIGATION as xr, CONTENT_NODE_LIST as Ur, CONTENT_NODE_BUTTON as Rr, CONTENT_NODE_FORM as Fr, CONTENT_NODE_QUOTE as Hr, CONTENT_NODE_TABLE as D, CONTENT_NODE_CARD as Mr, CONTENT_NODE_SEPARATOR as Br, CONTENT_NODE_SPACER as zr, CONTENT_NODE_PANEL as Wr, CONTENT_NODE_ACCORDION as $r, CONTENT_NODE_VIDEO as Gr, CONTENT_NODE_CODE as qr, CONTENT_NODE_SLIDER as Yr, CONTENT_NODE_GALLERY as Vr, CONTENT_NODE_IMAGE as b, CONTENT_NODE_TEXT as L, CONTENT_NODE_HEADING as S, LAYOUT_NODE_FULL_WIDTH_COLUMN as Qr, LAYOUT_NODE_RIGHT_SIDEBAR as jr, LAYOUT_NODE_LEFT_SIDEBAR as Xr, LAYOUT_NODE_QUADRUPLE_COLUMN as Kr, LAYOUT_NODE_TRIPLE_COLUMN as Jr, LAYOUT_NODE_DOUBLE_COLUMN as Zr, LAYOUT_NODE_SINGLE_COLUMN as dr, BASE_COLUMN as y, getBaseLayoutNode as E, getBaseContentNode as Sr } from "@apptegy/page-builder";
const ti = "ts-one-column", ri = "ts-two-column", ii = "ts-three-column", ei = "ts-four-column", v = "ts-full-width", si = "ts-left-sidebar", ai = "ts-right-sidebar", I = "pb-shared-content-block", ci = "ts-heading", oi = "ts-text", pi = "ts-video", ni = "ts-embed", li = "ts-slider", gi = "ts-spacer", mi = "ts-image", ui = "ts-gallery", fi = "ts-divider", _i = "ts-accordion", Di = "ts-table", hi = "ts-table-v2", Ti = "ts-button", Ci = "ts-card", Ni = "ts-quote", bi = "ts-form", Ii = "ts-list", Oi = "ts-navigation", Hi = (t, i) => {
  var n;
  const a = i || {};
  return [
    {
      id: t.id,
      name: t.name,
      component: t.type,
      properties: yi(t),
      config: (n = t.nodes) == null ? void 0 : n.map((l) => [w(l, a)])
    }
  ];
}, w = (t, i) => {
  var a, n, l, h, m, u;
  switch (t.type) {
    case dr:
      return s(e({}, C(t, i)), {
        name: "One Column",
        component: ti
      });
    case Zr:
      return s(e({}, C(t, i)), {
        name: "2 Columns",
        component: ri
      });
    case Jr:
      return s(e({}, C(t, i)), {
        name: "3 Columns",
        component: ii
      });
    case Kr:
      return s(e({}, C(t, i)), {
        name: "4 Columns",
        component: ei
      });
    case Xr:
      return s(e({}, C(t, i)), {
        name: "Left Sidebar",
        component: si
      });
    case jr:
      return s(e({}, C(t, i)), {
        name: "Right Sidebar",
        component: ai
      });
    case Qr:
      return s(e({}, C(t, i)), {
        name: "Full Width",
        component: v
      });
    case S:
      return {
        id: t.id,
        name: "Headline",
        component: ci,
        config: {
          blockId: t.id,
          content: t.content.html
        },
        properties: _(t),
        hasForm: !1
      };
    case L:
      return {
        id: t.id,
        name: "Text",
        component: oi,
        config: {
          blockId: t.id,
          content: t.content.html
        },
        properties: _(t),
        hasForm: !1
      };
    case b: {
      const o = {
        image: {
          // CONTENT
          url: (t == null ? void 0 : t.assetUrl) || ((a = t == null ? void 0 : t.content) == null ? void 0 : a.assetUrl) || ((n = i[t.content.assetId]) == null ? void 0 : n.url) || "",
          asset_id: t.content.assetId,
          alt_text: t.content.altText,
          caption: t.content.caption,
          link_url: t.content.link,
          // PROPERTIES
          set_ratio: t.properties.columnPercentage / 100,
          is_resized: t.properties.isResized,
          action_on_click: t.properties.actionOnClick,
          open_link_in_new_tab: t.properties.newTab,
          image_alignment: t.properties.imageAlignment,
          caption_alignment: t.properties.captionAlignment,
          show_caption: !!t.properties.showCaption,
          display: t.properties.resizeMode,
          cropped_width: t.properties.naturalWidth,
          cropped_height: t.properties.naturalHeight,
          preferred_width: t.properties.preferredWidth,
          preferred_height: t.properties.preferredHeight,
          decorative_image: t.properties.isDecorative,
          backgroundPosition: t.properties.backgroundPosition || "center",
          tilePercentage: t.properties.tilePercentage || 100
        }
      };
      return {
        id: t.id,
        name: "Image",
        component: mi,
        config: o,
        properties: _(t),
        hasForm: !0
      };
    }
    case Vr: {
      const o = {
        blockId: t.id,
        gallery: {
          images: t.content.images.map((r) => {
            var c, f;
            return {
              url: (r == null ? void 0 : r.assetUrl) || ((c = r == null ? void 0 : r.content) == null ? void 0 : c.assetUrl) || ((f = i[r.content.assetId]) == null ? void 0 : f.url) || "",
              // URL is not included in the new version
              sizes: {},
              // Sizes are not included in the new version
              alt_text: r.content.altText,
              asset_id: r.content.assetId,
              cropped_width: r.properties.naturalWidth,
              cropped_height: r.properties.naturalHeight,
              decorative_image: r.properties.isDecorative,
              caption: r.content.caption,
              focalPointPosition: r.properties.focalPointPosition
            };
          }),
          columns: t.properties.columnsCount,
          hasLightbox: t.properties.isLightbox,
          showCaptions: t.properties.showCaptions,
          captionsAlignment: t.properties.captionsAlignment
        }
      };
      return {
        id: t.id,
        name: "Gallery",
        config: o,
        properties: _(t),
        hasForm: !0,
        component: ui
      };
    }
    case Yr: {
      const o = {
        blockId: t.id,
        slider: {
          images: t.content.images.map((r) => {
            var c, f;
            return {
              url: (r == null ? void 0 : r.assetUrl) || ((c = r == null ? void 0 : r.content) == null ? void 0 : c.assetUrl) || ((f = i[r.content.assetId]) == null ? void 0 : f.url) || "",
              // URL is not included in the new version
              sizes: {},
              // Sizes are not included in the new version
              alt_text: r.content.altText,
              asset_id: r.content.assetId,
              caption: r.content.caption,
              link_url: r.content.link,
              action_on_click: r.properties.actionOnClick,
              open_link_in_new_tab: r.properties.newTab,
              decorative_image: r.properties.isDecorative,
              focalPointPosition: r.properties.focalPointPosition,
              cropped_height: r.properties.naturalHeight,
              // NEW
              cropped_width: r.properties.naturalWidth
              // NEW
            };
          }),
          has_dots: t.properties.showDots,
          dot_position: t.properties.dotsPosition,
          has_arrows: t.properties.showArrows,
          arrow_position: t.properties.arrowsPosition,
          is_autoplay: t.properties.isAutoplay,
          transition: t.properties.transitionSpeed
        }
      };
      return {
        id: t.id,
        name: "Slider",
        config: o,
        properties: _(t),
        hasForm: !0,
        component: li
      };
    }
    case qr:
      return {
        id: t.id,
        name: "Code",
        component: ni,
        config: {
          blockId: t.id,
          embed: t.content.html,
          hasScriptTag: t.properties.hasScriptTag
        },
        properties: _(t),
        hasForm: !1
      };
    case Gr:
      return {
        id: t.id,
        name: "Video",
        component: pi,
        config: {
          blockId: t.id,
          video: {
            url: t.content.embeddableUrl,
            isAutoplay: !1
          }
        },
        properties: _(t),
        hasForm: !0
      };
    case $r:
      return {
        id: t.id,
        name: "Accordion",
        component: _i,
        config: {
          blockId: t.id,
          accordion: {
            theme: t.properties.theme,
            icon_style: t.properties.iconStyle,
            allow_multiple_open_panels: t.properties.allowMultipleOpenPanels,
            items: t.nodes[0].nodes.map((o) => e({}, w(o, i)))
          }
        },
        properties: _(t),
        hasForm: !0
      };
    case Wr:
      return {
        id: t.id,
        text: t.properties.text,
        panelExpanded: t.properties.panelExpanded,
        content: t.nodes[0].nodes.map((o) => e({}, w(o, i))),
        properties: _(t)
      };
    case zr:
      return {
        id: t.id,
        name: "Space",
        config: {
          blockId: t.id,
          spacer: {
            height: t.properties.height,
            backgroundColor: t.properties.backgroundColor || "#ffffff",
            isTransparent: t.properties.isTransparent || !1
          }
        },
        properties: _(t),
        hasForm: !0,
        component: gi
      };
    case Br:
      return {
        id: t.id,
        name: "Separator",
        component: fi,
        config: {
          blockId: t.id,
          divider: {
            thickness: t.properties.thickness,
            style: "solid",
            width: t.properties.width,
            color: { hex: t.properties.color }
          }
        },
        properties: _(t),
        hasForm: !0
      };
    case Mr: {
      const { heading: o, text: r, image: c } = t.content, f = {
        blockId: t.id,
        card: {
          headline: o.content.html,
          content: r.content.html,
          image: {
            url: (c == null ? void 0 : c.assetUrl) || ((l = c == null ? void 0 : c.content) == null ? void 0 : l.assetUrl) || ((h = i[c.content.assetId]) == null ? void 0 : h.url) || "",
            alt_text: c.content.altText,
            asset_id: c.content.assetId,
            decorative_image: c.properties.isDecorative,
            focalPointPosition: c.properties.focalPointPosition,
            cropped_height: c.properties.naturalHeight,
            // NEW
            cropped_width: c.properties.naturalWidth,
            // NEW
            sizes: {}
            // Sizes are not included in the new version
          },
          design: t.properties.design,
          hasImage: t.properties.showImage,
          hasHeadline: t.properties.showHeadline,
          imageRight: t.properties.imagePosition === "right",
          wrapText: t.properties.wrapText
        }
      };
      return {
        id: t.id,
        name: "Card",
        component: Ci,
        config: f,
        properties: _(t),
        hasForm: !0
      };
    }
    case D:
      return {
        id: t.id,
        name: "Table",
        component: hi,
        config: {
          table: {
            content: t.content.html,
            theme: t.properties.theme,
            alternatingColors: t.properties.alternatingColors
          },
          blockId: t.id
        },
        properties: _(t),
        hasForm: !0
      };
    case Hr:
      return {
        id: t.id,
        name: "Quote",
        component: Ni,
        config: {
          blockId: t.id,
          quote: {
            content: t.content.quote,
            author: t.content.author,
            source: t.content.source,
            design: t.properties.design,
            color: {
              hex: t.properties.color
            }
          }
        },
        properties: _(t),
        hasForm: !0
      };
    case Fr: {
      const o = t.content.formId == null ? {} : {
        blockId: t.id,
        form: {
          form_id: t.content.formId,
          show_one_question_at_time: t.properties.showOneQuestionAtATime
        }
      };
      return {
        id: t.id,
        name: "Form",
        component: bi,
        config: o,
        properties: _(t),
        hasForm: !0
      };
    }
    case Rr: {
      const o = {
        button: {
          // Properties
          size: t.properties.size,
          type: t.properties.type,
          theme: t.properties.theme,
          alignment: t.properties.alignment,
          pill: t.properties.pillShape,
          style: t.properties.style,
          has_icons: t.properties.hasIcons,
          // Content
          buttons: (u = (m = t.content) == null ? void 0 : m.buttons) == null ? void 0 : u.map((r) => s(e(e({
            title: r.title,
            link: r.link,
            open_link_in_new_tab: r.newTab
          }, r.icon ? { icon: r.icon } : {}), r.iconId ? { icon_id: r.iconId } : {}), {
            mailto: r.mailto
          }))
        },
        blockId: t.id
      };
      return {
        id: t.id,
        name: "Button",
        config: o,
        properties: _(t),
        hasForm: !0,
        component: Ti
      };
    }
    case Ur:
      return {
        id: t.id,
        name: "List",
        config: {
          list: {
            items: [...t.content.items],
            design: t.properties.design,
            format: t.properties.format
          },
          blockId: t.id
        },
        properties: _(t),
        hasForm: !0,
        component: Ii
      };
    case xr:
      return {
        id: t.id,
        name: "Navigation",
        config: {
          selectedPageId: t.content.selectedPageId,
          selectedChildrenIds: t.content.selectedChildrenIds,
          design: t.properties.design,
          color: t.properties.color
        },
        hasForm: !0,
        component: Oi
      };
    case vr:
      return {
        id: t.id,
        name: I,
        config: {
          id: t.id,
          name: I,
          type: I,
          sharedContentId: `${t.sharedContentId}`,
          properties: t.properties
        },
        hasForm: !0,
        component: I
      };
    default:
      return console.error("Unhandled node type: ", t), t;
  }
}, C = (t, i) => ({
  id: t.id,
  properties: yi(t),
  config: Li(t, i),
  hasForm: !1
}), _ = (t) => {
  var i, a;
  return {
    anchorTag: ((i = t.properties) == null ? void 0 : i.anchorTag) || "",
    customClasses: ((a = t.properties) == null ? void 0 : a.customClasses) || []
  };
}, Li = (t, i) => t.nodes ? t.nodes.map((n) => {
  var l;
  return ((l = n.nodes) == null ? void 0 : l.map((h) => w(h, i))) || n;
}) : t, yi = (t) => {
  var i, a, n;
  return s(e({}, t.properties), {
    borderRadius: s(e({}, t.properties.borderRadius), {
      value: Number((i = t.properties.borderRadius) == null ? void 0 : i.value) || 0
    }),
    padding: s(e({}, t.properties.padding), {
      value: Number((a = t.properties.padding) == null ? void 0 : a.value) || 0
    }),
    margin: s(e({}, t.properties.margin), {
      value: Number((n = t.properties.margin) == null ? void 0 : n.value) || 0
    }),
    backgroundColor: s(e({}, t.properties.backgroundColor), {
      value: t.properties.backgroundColor.value || ""
    }),
    backgroundImage: s(e({}, t.properties.backgroundImage), {
      image: t.properties.backgroundImage.image || null
    })
  });
}, Si = (t) => {
  const { header: i, matrix: a, orientation: n, textAlign: l, bold: h } = e({ header: [] }, t), m = (o) => {
    const r = o == null ? "<p></p>" : o;
    if (l !== "center")
      return r;
    const c = /<p>/, f = /<p style=".*">/;
    return r.match(c) ? r.replace("<p>", `<p style="text-align: ${l};">`) : r.match(f) ? r.match(f)[0].includes("text-align:") ? r : r.replace('<p style="', `<p style="text-align: ${l};`) : r;
  }, u = ["<table>"];
  if (n === "horizontal")
    if (h) {
      const o = a.map((r, c) => ["<tr>", `<th scope="row">${m(i[c].value)}</th>`, ...r.map((f) => `<td>${m(f.value)}</td>`), "</tr>"].join(""));
      u.push(...o);
    } else {
      const o = a.map((r, c) => ["<tr>", `<td>${m(i[c].value)}</td>`, ...r.map((f) => `<td>${m(f.value)}</td>`), "</tr>"].join(""));
      u.push(...o);
    }
  else {
    if (i.length > 0)
      if (h) {
        const r = i.map((c) => `<th scope="col">${m(c.value)}</th>`);
        u.push("<tr>", ...r, "</tr>");
      } else {
        const r = i.map((c) => `<td>${m(c.value)}</td>`);
        u.push("<tr>", ...r, "</tr>");
      }
    const o = a.map((r) => ["<tr>", ...r.map((c) => `<td>${m(c.value)}</td>`), "</tr>"].join(""));
    u.push(...o);
  }
  return u.push("</table>"), u.join("");
};
let k;
const Mi = (t) => {
  var h, m;
  k = {};
  let i = [];
  ((h = t[0]) == null ? void 0 : h.id) === "root" ? i = t[0].config.flat() : i = t;
  const a = i.map((u) => x(u)), n = ((m = t[0]) == null ? void 0 : m.properties) || {
    backgroundColor: {
      toggle: !1,
      value: ""
    },
    backgroundImage: {
      toggle: !1,
      image: null
    }
  };
  return {
    structure: {
      id: "root",
      name: "Root",
      type: y,
      properties: n,
      nodes: a
    },
    assets: k
  };
}, vi = ({ component: t }) => {
  const i = t === v;
  return {
    borderRadius: {
      value: 0
    },
    backgroundColor: {
      toggle: !1,
      value: ""
    },
    backgroundImage: {
      toggle: !1,
      image: null
    },
    margin: {
      linked: !i,
      value: 10,
      top: 10,
      bottom: 10,
      left: i ? 0 : 10,
      right: i ? 0 : 10
    },
    padding: {
      linked: !0,
      value: 0,
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    },
    customClasses: [],
    anchorTag: ""
  };
}, x = (t) => {
  var i, a, n, l, h, m, u, o, r, c, f, A, U, R, F, H, M, B, z, W, $, G, q, Y, V, Q, j, X, K, J, Z, d, tt, rt, it, et, st, at, ct, ot, pt, nt, lt, gt, mt, ut, ft, _t, ht, Tt, Ct, Nt, bt, It, Ot, yt, Et, wt, kt, At, Pt, Dt, Lt, St, vt, xt, Ut, Rt, Ft, Ht, Mt, Bt, zt, Wt, $t, Gt, qt, Yt, Vt, Qt, jt, Xt, Kt, Jt, Zt, dt, tr, rr, ir, er, sr, ar, cr, or, pr, nr, lr, gr, mr, ur, fr, _r, hr, Tr, Cr, Nr, br, Ir, Or, yr, Er, wr, kr, Ar, Pr;
  switch (t == null ? void 0 : t.component) {
    case ti:
      return s(e({}, N(t)), {
        name: "One Column",
        type: dr
      });
    case ri:
      return s(e({}, N(t)), {
        name: "Two Columns",
        type: Zr
      });
    case ii:
      return s(e({}, N(t)), {
        name: "Three Columns",
        type: Jr
      });
    case ei:
      return s(e({}, N(t)), {
        name: "Four Columns",
        type: Kr
      });
    case si:
      return s(e({}, N(t)), {
        name: "Left Sidebar",
        type: Xr
      });
    case ai:
      return s(e({}, N(t)), {
        name: "Right Sidebar",
        type: jr
      });
    case v:
      return s(e({}, N(t)), {
        name: "Full Width",
        type: Qr
      });
    case ci:
      return {
        id: t.id,
        name: "Heading",
        type: S,
        content: {
          html: t.config.content
        },
        properties: g(t)
      };
    case oi:
      return {
        id: t.id,
        name: "Text",
        type: L,
        content: {
          html: t.config.content
        },
        properties: g(t)
      };
    case gi:
      return {
        id: t.id,
        name: "Spacer",
        type: zr,
        properties: s(e({}, g(t)), {
          height: t.config.spacer.height,
          backgroundColor: t.config.spacer.backgroundColor || "#ffffff",
          isTransparent: t.config.spacer.isTransparent || !1
        })
      };
    case fi:
      return {
        id: t.id,
        name: "Separator",
        type: Br,
        properties: s(e(e({}, g(t)), t.config.divider), {
          color: (i = t.config.divider.color) == null ? void 0 : i.hex,
          style: ((a = t.config.divider) == null ? void 0 : a.style) || "solid"
        })
      };
    case ni:
      return {
        id: t.id,
        name: "Code",
        type: qr,
        content: {
          html: t.config.embed
        },
        properties: s(e({}, g(t)), {
          hasScriptTag: t.config.hasScriptTag
        })
      };
    case pi:
      return {
        id: t.id,
        name: "Video",
        type: Gr,
        content: {
          rawUrl: "",
          embeddableUrl: t.config.video.url,
          isResized: !1,
          videoAlignment: "center",
          width: "100%"
        },
        properties: g(t)
      };
    case Ni:
      return {
        id: t.id,
        name: "Quote",
        type: Hr,
        content: {
          quote: t.config.quote.content,
          author: t.config.quote.author,
          source: t.config.quote.source
        },
        properties: s(e({}, g(t)), {
          design: t.config.quote.design,
          color: t.config.quote.color.hex
        })
      };
    case mi: {
      O((l = (n = t == null ? void 0 : t.config) == null ? void 0 : n.image) == null ? void 0 : l.asset_id, (m = (h = t == null ? void 0 : t.config) == null ? void 0 : h.image) == null ? void 0 : m.url);
      const T = ((o = (u = t == null ? void 0 : t.config) == null ? void 0 : u.image) == null ? void 0 : o.show_caption) === null || ((c = (r = t == null ? void 0 : t.config) == null ? void 0 : r.image) == null ? void 0 : c.show_caption) === void 0 ? !0 : !!((A = (f = t == null ? void 0 : t.config) == null ? void 0 : f.image) != null && A.show_caption);
      return {
        id: t.id,
        name: "Image",
        type: b,
        assetUrl: ((R = (U = t == null ? void 0 : t.config) == null ? void 0 : U.image) == null ? void 0 : R.url) || "",
        content: {
          assetUrl: ((H = (F = t == null ? void 0 : t.config) == null ? void 0 : F.image) == null ? void 0 : H.url) || "",
          assetId: ((B = (M = t == null ? void 0 : t.config) == null ? void 0 : M.image) == null ? void 0 : B.asset_id) || "",
          altText: ((W = (z = t == null ? void 0 : t.config) == null ? void 0 : z.image) == null ? void 0 : W.alt_text) || "",
          caption: ((G = ($ = t == null ? void 0 : t.config) == null ? void 0 : $.image) == null ? void 0 : G.caption) || "",
          link: ((Y = (q = t == null ? void 0 : t.config) == null ? void 0 : q.image) == null ? void 0 : Y.link_url) || ""
        },
        properties: s(e({}, g(t)), {
          actionOnClick: ((Q = (V = t == null ? void 0 : t.config) == null ? void 0 : V.image) == null ? void 0 : Q.action_on_click) || "no-action",
          newTab: ((X = (j = t == null ? void 0 : t.config) == null ? void 0 : j.image) == null ? void 0 : X.open_link_in_new_tab) || !1,
          imageAlignment: ((J = (K = t == null ? void 0 : t.config) == null ? void 0 : K.image) == null ? void 0 : J.image_alignment) || "",
          captionAlignment: ((d = (Z = t == null ? void 0 : t.config) == null ? void 0 : Z.image) == null ? void 0 : d.caption_alignment) || "",
          columnPercentage: ((rt = (tt = t == null ? void 0 : t.config) == null ? void 0 : tt.image) == null ? void 0 : rt.set_ratio) * 100 || 0,
          isResized: !!((et = (it = t == null ? void 0 : t.config) == null ? void 0 : it.image) != null && et.is_resized),
          resizeMode: ((at = (st = t == null ? void 0 : t.config) == null ? void 0 : st.image) == null ? void 0 : at.display) || "actual-size",
          showCaption: T,
          isDecorative: ((ot = (ct = t == null ? void 0 : t.config) == null ? void 0 : ct.image) == null ? void 0 : ot.decorative_image) || !1,
          naturalWidth: ((nt = (pt = t == null ? void 0 : t.config) == null ? void 0 : pt.image) == null ? void 0 : nt.cropped_width) || 0,
          naturalHeight: ((gt = (lt = t == null ? void 0 : t.config) == null ? void 0 : lt.image) == null ? void 0 : gt.cropped_height) || 0,
          preferredWidth: ((ut = (mt = t == null ? void 0 : t.config) == null ? void 0 : mt.image) == null ? void 0 : ut.preferred_width) || 0,
          preferredHeight: ((_t = (ft = t == null ? void 0 : t.config) == null ? void 0 : ft.image) == null ? void 0 : _t.preferred_height) || 0
        })
      };
    }
    case ui: {
      const T = t.config.gallery.images.map((p) => (O(p.asset_id, p.url), {
        name: "Image",
        type: b,
        assetUrl: p.url,
        content: {
          assetUrl: p.url,
          assetId: p.asset_id,
          altText: p.alt_text,
          caption: p.caption || ""
          // New
        },
        properties: s(e({}, g(t)), {
          isDecorative: p.decorative_image,
          naturalWidth: p.cropped_width,
          naturalHeight: p.cropped_height,
          focalPointPosition: p.focalPointPosition || {
            // New
            x: 50,
            y: 50
          }
        })
      }));
      return {
        id: t.id,
        name: "Gallery",
        type: Vr,
        content: {
          images: T
        },
        properties: s(e({}, g(t)), {
          columnsCount: t.config.gallery.columns,
          isLightbox: t.config.gallery.hasLightbox,
          showCaptions: t.config.gallery.showCaptions || !1,
          // New
          captionsAlignment: t.config.gallery.captionsAlignment || "center"
          // New
        })
      };
    }
    case li: {
      const T = t.config.slider.images.map((p) => (O(p.asset_id, p.url), {
        name: "Image",
        type: b,
        assetUrl: p.url,
        content: {
          assetUrl: p.url,
          assetId: p.asset_id,
          altText: p.alt_text,
          caption: p.caption || "",
          // New
          link: p.link_url || ""
        },
        properties: s(e({}, g(t)), {
          actionOnClick: p.action_on_click,
          newTab: p.open_link_in_new_tab,
          isDecorative: p.decorative_image,
          naturalWidth: p.cropped_width || 0,
          // New
          naturalHeight: p.cropped_height || 0,
          // New
          focalPointPosition: p.focalPointPosition || {
            // New
            x: 50,
            y: 50
          }
        })
      }));
      return {
        id: t.id,
        name: "Slider",
        type: Yr,
        content: {
          images: T
        },
        properties: s(e({}, g(t)), {
          showDots: t.config.slider.has_dots,
          dotsPosition: t.config.slider.dot_position === "bottom" ? "below" : t.config.slider.dot_position,
          showArrows: t.config.slider.has_arrows,
          arrowsPosition: t.config.slider.arrow_position,
          isAutoplay: t.config.slider.is_autoplay,
          transitionSpeed: t.config.slider.transition
        })
      };
    }
    case Ti:
      return {
        id: t.id,
        name: "Button",
        type: Rr,
        content: {
          buttons: ((Ct = (Tt = (ht = t.config) == null ? void 0 : ht.button) == null ? void 0 : Tt.buttons) == null ? void 0 : Ct.map((T) => ({
            title: T.title,
            link: T.link,
            newTab: T.open_link_in_new_tab || !1,
            mailto: T.mailto || !1,
            icon: T.icon || null,
            iconId: T.icon_id || null
          }))) || []
        },
        properties: s(e({}, g(t)), {
          type: ((bt = (Nt = t.config) == null ? void 0 : Nt.button) == null ? void 0 : bt.type) || "regular",
          theme: ((Ot = (It = t.config) == null ? void 0 : It.button) == null ? void 0 : Ot.theme) || "light",
          size: ((Et = (yt = t.config) == null ? void 0 : yt.button) == null ? void 0 : Et.size) || "regular",
          pillShape: !!((kt = (wt = t.config) == null ? void 0 : wt.button) != null && kt.pill),
          alignment: ((Pt = (At = t.config) == null ? void 0 : At.button) == null ? void 0 : Pt.alignment) || "left",
          style: ((Lt = (Dt = t.config) == null ? void 0 : Dt.button) == null ? void 0 : Lt.style) || "1",
          hasIcons: !!((vt = (St = t.config) == null ? void 0 : St.button) != null && vt.has_icons)
        })
      };
    case Ci:
      return O((Rt = (Ut = (xt = t == null ? void 0 : t.config) == null ? void 0 : xt.card) == null ? void 0 : Ut.image) == null ? void 0 : Rt.asset_id, (Mt = (Ht = (Ft = t == null ? void 0 : t.config) == null ? void 0 : Ft.card) == null ? void 0 : Ht.image) == null ? void 0 : Mt.url), {
        id: t.id,
        name: "Card",
        type: Mr,
        content: {
          heading: Sr({
            id: `cardTitle_${t.id}`,
            type: S,
            content: { html: (zt = (Bt = t == null ? void 0 : t.config) == null ? void 0 : Bt.card) == null ? void 0 : zt.headline }
          }),
          text: Sr({
            id: `cardContent_${t.id}`,
            type: L,
            content: { html: ($t = (Wt = t == null ? void 0 : t.config) == null ? void 0 : Wt.card) == null ? void 0 : $t.content }
          }),
          image: {
            name: "Image",
            type: b,
            assetUrl: ((Yt = (qt = (Gt = t == null ? void 0 : t.config) == null ? void 0 : Gt.card) == null ? void 0 : qt.image) == null ? void 0 : Yt.url) || "",
            content: {
              assetUrl: ((jt = (Qt = (Vt = t == null ? void 0 : t.config) == null ? void 0 : Vt.card) == null ? void 0 : Qt.image) == null ? void 0 : jt.url) || "",
              assetId: ((Jt = (Kt = (Xt = t == null ? void 0 : t.config) == null ? void 0 : Xt.card) == null ? void 0 : Kt.image) == null ? void 0 : Jt.asset_id) || "",
              altText: ((tr = (dt = (Zt = t == null ? void 0 : t.config) == null ? void 0 : Zt.card) == null ? void 0 : dt.image) == null ? void 0 : tr.alt_text) || ""
            },
            properties: {
              isDecorative: ((er = (ir = (rr = t == null ? void 0 : t.config) == null ? void 0 : rr.card) == null ? void 0 : ir.image) == null ? void 0 : er.decorative_image) || !1,
              naturalWidth: ((cr = (ar = (sr = t == null ? void 0 : t.config) == null ? void 0 : sr.card) == null ? void 0 : ar.image) == null ? void 0 : cr.cropped_width) || 0,
              // New
              naturalHeight: ((nr = (pr = (or = t == null ? void 0 : t.config) == null ? void 0 : or.card) == null ? void 0 : pr.image) == null ? void 0 : nr.cropped_height) || 0,
              // New
              focalPointPosition: ((mr = (gr = (lr = t == null ? void 0 : t.config) == null ? void 0 : lr.card) == null ? void 0 : gr.image) == null ? void 0 : mr.focalPointPosition) || {
                // New
                x: 50,
                y: 50
              }
            }
          }
        },
        properties: s(e({}, g(t)), {
          design: ((fr = (ur = t == null ? void 0 : t.config) == null ? void 0 : ur.card) == null ? void 0 : fr.design) || "box-shadow",
          showImage: ((hr = (_r = t == null ? void 0 : t.config) == null ? void 0 : _r.card) == null ? void 0 : hr.hasImage) || !1,
          showHeadline: ((Cr = (Tr = t == null ? void 0 : t.config) == null ? void 0 : Tr.card) == null ? void 0 : Cr.hasHeadline) || !1,
          imagePosition: (br = (Nr = t == null ? void 0 : t.config) == null ? void 0 : Nr.card) != null && br.imageRight ? "right" : "left",
          wrapText: ((Or = (Ir = t == null ? void 0 : t.config) == null ? void 0 : Ir.card) == null ? void 0 : Or.wrapText) || !1,
          textCursor: ((Er = (yr = t == null ? void 0 : t.config) == null ? void 0 : yr.card) == null ? void 0 : Er.textCursor) || 0,
          headlineCursor: ((kr = (wr = t == null ? void 0 : t.config) == null ? void 0 : wr.card) == null ? void 0 : kr.headlineCursor) || 0
        })
      };
    case bi:
      return {
        id: t.id,
        name: "Form",
        type: Fr,
        content: {
          formId: ((Ar = t.config.form) == null ? void 0 : Ar.form_id) || null
        },
        properties: s(e({}, g(t)), {
          showOneQuestionAtATime: ((Pr = t.config.form) == null ? void 0 : Pr.show_one_question_at_time) || !1
        })
      };
    case Di:
      return {
        id: t.id,
        name: "Table",
        type: D,
        content: {
          html: Si(t.config.table)
        },
        properties: s(e({}, g(t)), {
          theme: "default",
          alternatingColors: !1
        })
      };
    case hi:
      return {
        id: t.id,
        name: "Table",
        type: D,
        content: {
          html: t.config.table.content
        },
        properties: s(e({}, g(t)), {
          theme: t.config.table.theme,
          alternatingColors: t.config.table.alternatingColors
        })
      };
    case _i: {
      const T = t.config.accordion.icon_style === "minus" ? "plus" : t.config.accordion.icon_style, p = {
        id: t.id,
        name: "Accordion",
        type: $r,
        properties: s(e({}, g(t)), {
          theme: t.config.accordion.theme,
          iconStyle: T,
          allowMultipleOpenPanels: t.config.accordion.allow_multiple_open_panels
        }),
        nodes: [
          s(e({}, E({ type: y })), {
            nodes: t.config.accordion.items.map((P) => xi(P))
          })
        ]
      };
      return p.nodes[0].nodes.map((P) => P.parentAccordionId = p.id), p;
    }
    case Ii:
      return {
        id: t.id,
        name: "List",
        type: Ur,
        content: {
          items: [...t.config.list.items]
        },
        properties: s(e({}, g(t)), {
          design: t.config.list.design,
          format: t.config.list.format
        })
      };
    case Oi:
      return {
        id: t.id,
        name: "Navigation",
        type: xr,
        content: {
          selectedPageId: t.config.selectedPageId,
          selectedChildrenIds: t.config.selectedChildrenIds
        },
        properties: {
          design: t.config.design,
          color: t.config.color
        }
      };
    case I:
      return {
        id: t.id,
        name: "Shared content",
        type: vr,
        sharedContentId: t.config.sharedContentId,
        properties: t.config.properties,
        nodes: [
          e({}, E({ type: y }))
        ]
      };
    default:
      return console.error("Unhandled node type: ", t), t;
  }
}, xi = (t) => ({
  id: t.id,
  name: "Accordion Panel",
  type: Wr,
  properties: s(e({}, g(t)), {
    text: t.text,
    panelExpanded: t.panelExpanded
  }),
  nodes: [
    s(e({}, E({ type: y })), {
      nodes: t.content.map((i) => x(i))
    })
  ]
}), O = (t, i) => {
  k = s(e({}, k), {
    [t]: {
      url: i
    }
  });
}, N = (t) => {
  var a, n, l, h, m, u, o, r;
  (l = (n = (a = t.properties) == null ? void 0 : a.backgroundImage) == null ? void 0 : n.image) != null && l.content && O(
    (u = (m = (h = t.properties.backgroundImage) == null ? void 0 : h.image) == null ? void 0 : m.content) == null ? void 0 : u.assetId,
    (r = (o = t.properties.backgroundImage) == null ? void 0 : o.image) == null ? void 0 : r.assetUrl
  );
  const i = e({
    customClasses: [],
    anchorTag: ""
  }, t.properties || vi(t));
  return {
    id: t.id,
    properties: i,
    nodes: Ui(t)
  };
}, g = (t) => {
  var i, a;
  return {
    anchorTag: ((i = t.properties) == null ? void 0 : i.anchorTag) || "",
    customClasses: ((a = t.properties) == null ? void 0 : a.customClasses) || []
  };
}, Ui = (t) => t.config ? t.config.map((a) => {
  const n = a.map((l) => x(l));
  return s(e({}, E({ type: y })), {
    nodes: n
  });
}).flat() : [];
export {
  Mi as convertLegacyPageConfigToPageBuilderConfig,
  Hi as convertPageBuilderConfigToLegacyPageConfig,
  Si as convertTableToV2
};
